module.exports = __webpack_public_path__ + "img/phpLogo.5bd7d39e.png";